import { atom } from 'jotai';

import { Maybe } from '@/types';
import { TdaInitialData } from '@/types/tda';

export const initialTdaState = {
  fechasDisponibles: [],
};

export const tdaDataAtom = atom<Maybe<TdaInitialData>>(initialTdaState);
